import { ComponentBase, Div, Switch, Text } from "@tblabs/truffle";
import { Markdown } from "../Utils/Markdown";
import { TextField } from "../../Models/Description/Text/TextField";
import { MarkdownField } from "../../Models/Description/Markdown/MarkdownField";
import { FaqsPrinter } from "./Faq/FaqsPrinter";
import { Gallery } from "./Gallery/Gallery";
import { FaqField } from "../../Models/Description/Faq/FaqField";
import { GalleryField } from "../../Models/Description/Gallery/GalleryField";
import { TableField } from "./Table/TableField";
import { Field } from "../../Models/Description/Field";
import { FieldType } from "../../Models/Description/FieldType";
import { OpinionsPrinter } from "./Opinion/OpinionsPrinter";
import { Center } from "../Utils/Center";
import { TablePrinter } from "./Table/TablePrinter";
import { OpinionField } from "../../Models/Description/Opinion/OpinionField";
import { TextWithPictureField } from "../../Models/Description/TextWithPicture/TextWithPictureField";
import { Heading } from "../Heading";
import { TextWithPicturePrinterV1 } from "./TextWithPicture/TextWithPicturePrinter";
import { Svg } from "../../Pages/Components/Utils/Svg";


export class DescriptionFieldPrinter extends Div
{
    constructor(field: Field)
    {
        super("description-field");

        if (field.VisibleHeader.value)
        {
            this.Append(
                new Div("product-description-field-header").Append(
                    field.Icon.value && new Svg(field.Icon.value).Class("svg-icon"),
                    new Heading(field.Header.value, 3).Class("product-info-title"),
                ),
            )
        }

        const printer = new Switch<FieldType, ComponentBase<any>>(field.Type)
            .Case(FieldType.Text, () => new Text((field as TextField).Text))
            .Case(FieldType.TextWithPicture, () => new TextWithPicturePrinterV1(field as TextWithPictureField))
            .Case(FieldType.Markdown, () => new Markdown((field as MarkdownField).Markdown.value).MarginLeftRight(8))
            .Case(FieldType.Faq, () => new FaqsPrinter(field as FaqField))
            .Case(FieldType.Opinion, () => new OpinionsPrinter(field as OpinionField))
            .Case(FieldType.Gallery, () => new Gallery((field as GalleryField).Images).Background("none").MarginAuto())
            .Case(FieldType.Table, () => new TablePrinter(field as TableField))
            .Default(() => new Center(`No printer for ${field.Type}`))
            .Execute(field.Type);

        printer?.Style(field.Style.value)

        this.Append(
            new Div("product-description-field-content").Append(
                printer
            )
        )
    }
}
